import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/workplace-xg/workplace-xg/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const Tabs = makeShortcode("Tabs");
const Tab = makeShortcode("Tab");
const ArtDirection = makeShortcode("ArtDirection");
const GifPlayer = makeShortcode("GifPlayer");
const Video = makeShortcode("Video");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Pattern studies are concepts that illustrate how pattern may be articulated in the built environment. These designs may be implemented in a variety of architectural installations and should be considered a signature element of the design.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Horizontal linear progression</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Vertical linear progression</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Intermittent linear progression</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Volumetric progression</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Rotating lenticular progression</AnchorLink>
    </AnchorLinks>
    <h2>{`Horizontal linear progression`}</h2>
    <h3>{`Design`}</h3>
    <p>{`Cut pieces are adhered to a backing substrate at regular intervals. This simple linear pattern recalls the IBM 8-bar logo and lines of data.`}</p>
    <h3>{`Finishes`}</h3>
    <p>{`This design solution can be built in a variety of materials and finishes. The example shown here uses painted MDF—a relatively affordable solution.`}</p>
    <Row mdxType="Row">
      <Column mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAIBAwX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHZLoEGD//EABgQAAMBAQAAAAAAAAAAAAAAAAAQEQEh/9oACAEBAAEFAtOkUX//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAUEAEAAAAAAAAAAAAAAAAAAAAg/9oACAEBAAY/Al//xAAZEAACAwEAAAAAAAAAAAAAAAABEQAQIVH/2gAIAQEAAT8hcDIIak5X/9oADAMBAAIAAwAAABCQD//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABoQAQACAwEAAAAAAAAAAAAAAAERIQAQQXH/2gAIAQEAAT8QB0Ez3AomL0IJYOPGHla//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "white on white horizontal progression render",
            "title": "white on white horizontal progression render",
            "src": "/workplace-xg/static/45cec89a9fe8a8dfcc470d81f32b4aa2/2e753/white-on-white-horizontal-progression-render.jpg",
            "srcSet": ["/workplace-xg/static/45cec89a9fe8a8dfcc470d81f32b4aa2/69549/white-on-white-horizontal-progression-render.jpg 288w", "/workplace-xg/static/45cec89a9fe8a8dfcc470d81f32b4aa2/473e3/white-on-white-horizontal-progression-render.jpg 576w", "/workplace-xg/static/45cec89a9fe8a8dfcc470d81f32b4aa2/2e753/white-on-white-horizontal-progression-render.jpg 1152w", "/workplace-xg/static/45cec89a9fe8a8dfcc470d81f32b4aa2/74f4b/white-on-white-horizontal-progression-render.jpg 1728w", "/workplace-xg/static/45cec89a9fe8a8dfcc470d81f32b4aa2/f35b7/white-on-white-horizontal-progression-render.jpg 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <div className="tabs-no-padding">
      <Tabs mdxType="Tabs">
        <Tab label="Elevation" mdxType="Tab">
          <ArtDirection mdxType="ArtDirection">
            <img {...{
              "src": "/workplace-xg/520971e2f7ed48f216d8efde99ab40af/mobile-horizontal-linear-progression-elevation.svg",
              "alt": "horizontal linear pattern studies",
              "title": "horizontal linear pattern studies"
            }}></img>
            <img {...{
              "src": "/workplace-xg/df09ae5b6cdc58c5bba53361ad390715/desktop-horizontal-linear-progression-elevation.svg",
              "alt": "horizontal linear pattern studies",
              "title": "horizontal linear pattern studies"
            }}></img>
          </ArtDirection>
        </Tab>
        <Tab label="Section sizes" mdxType="Tab">
          <ArtDirection mdxType="ArtDirection">
            <img {...{
              "src": "/workplace-xg/cb9b5bdeb3fc787e89f724c34dc356c2/mobile-horizontal-linear-progression-section-sizes.svg",
              "alt": "horizontal linear pattern studies",
              "title": "horizontal linear pattern studies"
            }}></img>
            <img {...{
              "src": "/workplace-xg/1635664ae988d73747d77edcbc430204/desktop-horizontal-linear-progression-section-sizes.svg",
              "alt": "horizontal linear pattern studies",
              "title": "horizontal linear pattern studies"
            }}></img>
          </ArtDirection>
        </Tab>
        <Tab label="Section progression" mdxType="Tab">
          <ArtDirection mdxType="ArtDirection">
            <img {...{
              "src": "/workplace-xg/2a8b933d9835c039731b3bbacd46e3e2/mobile-horizontal-linear-progression-section-progression.svg",
              "alt": "horizontal linear pattern studies",
              "title": "horizontal linear pattern studies"
            }}></img>
            <img {...{
              "src": "/workplace-xg/b2cd2e54f8df8a7ce18e3788e33273d6/desktop-horizontal-linear-progression-section-progression.svg",
              "alt": "horizontal linear pattern studies",
              "title": "horizontal linear pattern studies"
            }}></img>
          </ArtDirection>
        </Tab>
      </Tabs>
    </div>
    <h2>{`Vertical linear progression`}</h2>
    <h3>{`Design`}</h3>
    <p>{`This simple linear pattern abstractly references the computation of data. Cut pieces are adhered to a backing substrate at regular intervals within four rows of even height. The number of cut pieces within each row progress from top to bottom, doubling with each row.`}</p>
    <h3>{`Finishes`}</h3>
    <p>{`This design solution can be built in a variety of materials and finishes. The example shown here is created from anodized aluminum for a sleek, high-end look.`}</p>
    <Row mdxType="Row">
      <Column mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFAv/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAZTCeSsTQ//EABoQAAEFAQAAAAAAAAAAAAAAAAABAgMSEyD/2gAIAQEAAQUCsNmNU4//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAUEAEAAAAAAAAAAAAAAAAAAAAg/9oACAEBAAY/Al//xAAbEAADAAIDAAAAAAAAAAAAAAAAAREhMUHR8P/aAAgBAQABPyGrW6I17nstmjEI/9oADAMBAAIAAwAAABCQz//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABwQAQACAQUAAAAAAAAAAAAAAAEAESEQMUGRsf/aAAgBAQABPxBzDThYAUJhOwQWLM14GndE1P/Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "black on black render detail",
            "title": "black on black render detail",
            "src": "/workplace-xg/static/6b79fe624d9ac3a4790103a50cde8fab/2e753/black-on-black-render-detail.jpg",
            "srcSet": ["/workplace-xg/static/6b79fe624d9ac3a4790103a50cde8fab/69549/black-on-black-render-detail.jpg 288w", "/workplace-xg/static/6b79fe624d9ac3a4790103a50cde8fab/473e3/black-on-black-render-detail.jpg 576w", "/workplace-xg/static/6b79fe624d9ac3a4790103a50cde8fab/2e753/black-on-black-render-detail.jpg 1152w", "/workplace-xg/static/6b79fe624d9ac3a4790103a50cde8fab/74f4b/black-on-black-render-detail.jpg 1728w", "/workplace-xg/static/6b79fe624d9ac3a4790103a50cde8fab/f35b7/black-on-black-render-detail.jpg 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <div className="tabs-no-padding">
      <Tabs mdxType="Tabs">
        <Tab label="Elevation" mdxType="Tab">
          <ArtDirection mdxType="ArtDirection">
            <img {...{
              "src": "/workplace-xg/cd8cf7aad7f73f44cd121943b90e6ca5/mobile-vertical-linear-progression-elevation.svg",
              "alt": "vertical linear pattern studies",
              "title": "vertical linear pattern studies"
            }}></img>
            <img {...{
              "src": "/workplace-xg/63633ac18c6820d688357f62f573727b/desktop-vertical-linear-progression-elevation.svg",
              "alt": "vertical linear pattern studies",
              "title": "vertical linear pattern studies"
            }}></img>
          </ArtDirection>
        </Tab>
        <Tab label="Section" mdxType="Tab">
          <ArtDirection mdxType="ArtDirection">
            <img {...{
              "src": "/workplace-xg/80dbffc6e5b63c2edc93b8b2bb313bef/mobile-vertical-linear-progression-section.svg",
              "alt": "vertical linear pattern studies",
              "title": "vertical linear pattern studies"
            }}></img>
            <img {...{
              "src": "/workplace-xg/658bf4262f887a71d8d96787fba3ba95/desktop-vertical-linear-progression-section.svg",
              "alt": "vertical linear pattern studies",
              "title": "vertical linear pattern studies"
            }}></img>
          </ArtDirection>
        </Tab>
        <Tab label="Plan" mdxType="Tab">
          <ArtDirection mdxType="ArtDirection">
            <img {...{
              "src": "/workplace-xg/53b46522f1fe2cd375b4e4d4ff4e4ed0/mobile-vertical-linear-progression-plan.svg",
              "alt": "vertical linear pattern studies",
              "title": "vertical linear pattern studies"
            }}></img>
            <img {...{
              "src": "/workplace-xg/75a6f95191c33cfad35bba994347a071/desktop-vertical-linear-progression-plan.svg",
              "alt": "vertical linear pattern studies",
              "title": "vertical linear pattern studies"
            }}></img>
          </ArtDirection>
        </Tab>
      </Tabs>
    </div>
    <h2>{`Intermittent linear progression`}</h2>
    <h3>{`Design`}</h3>
    <p>{`Cut pieces are adhered to a backing substrate at regular intervals. This simple linear pattern recalls the IBM 8-bar logo and lines of data.`}</p>
    <h3>{`Finishes`}</h3>
    <p>{`This design solution can be built in a variety of materials and finishes. The example shown here uses painted MDF—a relatively affordable solution.`}</p>
    <Row mdxType="Row">
      <Column mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAQACBf/EABYBAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAAB6DlzSY//xAAWEAADAAAAAAAAAAAAAAAAAAABECD/2gAIAQEAAQUCgr//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAUEAEAAAAAAAAAAAAAAAAAAAAg/9oACAEBAAY/Al//xAAXEAADAQAAAAAAAAAAAAAAAAAAARAx/9oACAEBAAE/IUjIq//aAAwDAQACAAMAAAAQ5x//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAcEAEAAgIDAQAAAAAAAAAAAAABABEhMWFxoeH/2gAIAQEAAT8QMDjMQOC7zGl378j33USBEJ//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "wood positive detail render",
            "title": "wood positive detail render",
            "src": "/workplace-xg/static/99e5bc57dbcaa60912b875c765e61efd/2e753/wood-positive-detail-render.jpg",
            "srcSet": ["/workplace-xg/static/99e5bc57dbcaa60912b875c765e61efd/69549/wood-positive-detail-render.jpg 288w", "/workplace-xg/static/99e5bc57dbcaa60912b875c765e61efd/473e3/wood-positive-detail-render.jpg 576w", "/workplace-xg/static/99e5bc57dbcaa60912b875c765e61efd/2e753/wood-positive-detail-render.jpg 1152w", "/workplace-xg/static/99e5bc57dbcaa60912b875c765e61efd/74f4b/wood-positive-detail-render.jpg 1728w", "/workplace-xg/static/99e5bc57dbcaa60912b875c765e61efd/f35b7/wood-positive-detail-render.jpg 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <div className="tabs-no-padding">
      <Tabs mdxType="Tabs">
        <Tab label="Elevation" mdxType="Tab">
          <ArtDirection mdxType="ArtDirection">
            <img {...{
              "src": "/workplace-xg/870ba89c4b1e38fa54ec9da06d931297/mobile-intermittent-linear-progression-elevation.svg",
              "alt": "intermittent linear pattern studies",
              "title": "intermittent linear pattern studies"
            }}></img>
            <img {...{
              "src": "/workplace-xg/271f85cb779c182ed00add81731e5193/desktop-intermittent-linear-progression-elevation.svg",
              "alt": "intermittent linear pattern studies",
              "title": "intermittent linear pattern studies"
            }}></img>
          </ArtDirection>
        </Tab>
        <Tab label="Section" mdxType="Tab">
          <ArtDirection mdxType="ArtDirection">
            <img {...{
              "src": "/workplace-xg/659f02a7ee34abf22b94cdc222f1e1ae/mobile-intermittent-linear-progression-section.svg",
              "alt": "intermittent linear pattern studies",
              "title": "intermittent linear pattern studies"
            }}></img>
            <img {...{
              "src": "/workplace-xg/0dde852dceb7005872186855453dcf1f/desktop-intermittent-linear-progression-section.svg",
              "alt": "intermittent linear pattern studies",
              "title": "intermittent linear pattern studies"
            }}></img>
          </ArtDirection>
        </Tab>
        <Tab label="Plan" mdxType="Tab">
          <ArtDirection mdxType="ArtDirection">
            <img {...{
              "src": "/workplace-xg/a3ba48bc32f406a7cd305bc89d96ac7b/mobile-intermittent-linear-progression-plan.svg",
              "alt": "intermittent linear pattern studies",
              "title": "intermittent linear pattern studies"
            }}></img>
            <img {...{
              "src": "/workplace-xg/8be79cb85e6a1b7b377e8f31d9f9da26/desktop-intermittent-linear-progression-plan.svg",
              "alt": "intermittent linear pattern studies",
              "title": "intermittent linear pattern studies"
            }}></img>
          </ArtDirection>
        </Tab>
      </Tabs>
    </div>
    <h2>{`Volumetric progression`}</h2>
    <h3>{`Design`}</h3>
    <p>{`Linear geometry can be expressed in limitless ways. This pattern study is informed by the faceted design language of IBM Z® family. Using the 2x Grid, vertical wood slats create a slanted fin profile that’s reminiscent of our industrial design.`}</p>
    <h3>{`Finishes`}</h3>
    <p>{`This design solution can be built in a variety of materials and finishes. A blonde wood finish, combined with a painted return is one approach. To add more dynamism to the experience, each fin has one side painted blue, while the other return is left in a natural wood finish. This approach produces different effects for the viewers depending on their vantage point.`}</p>
    <Row mdxType="Row">
      <Column mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAQF/8QAFAEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABoaJMdYH/xAAbEAEAAQUBAAAAAAAAAAAAAAABEQACAxASIv/aAAgBAQABBQLL4It500hP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAFRABAQAAAAAAAAAAAAAAAAAAIDH/2gAIAQEABj8Ci//EABgQAAMBAQAAAAAAAAAAAAAAAAABEUEx/9oACAEBAAE/IYS9FqVpBCKcRkH/2gAMAwEAAgADAAAAEKQP/8QAFhEAAwAAAAAAAAAAAAAAAAAAARAx/9oACAEDAQE/EBV//8QAFhEBAQEAAAAAAAAAAAAAAAAAAREQ/9oACAECAQE/EFJJn//EABwQAQACAQUAAAAAAAAAAAAAAAEAESEQMWFxkf/aAAgBAQABPxBImroxLK524ih20vd+EtMJ/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "volumetric wood and blue render",
            "title": "volumetric wood and blue render",
            "src": "/workplace-xg/static/a2111fe69f23411744da10ddc2d5f38b/2e753/volumetric-wood-and-blue-render.jpg",
            "srcSet": ["/workplace-xg/static/a2111fe69f23411744da10ddc2d5f38b/69549/volumetric-wood-and-blue-render.jpg 288w", "/workplace-xg/static/a2111fe69f23411744da10ddc2d5f38b/473e3/volumetric-wood-and-blue-render.jpg 576w", "/workplace-xg/static/a2111fe69f23411744da10ddc2d5f38b/2e753/volumetric-wood-and-blue-render.jpg 1152w", "/workplace-xg/static/a2111fe69f23411744da10ddc2d5f38b/74f4b/volumetric-wood-and-blue-render.jpg 1728w", "/workplace-xg/static/a2111fe69f23411744da10ddc2d5f38b/f35b7/volumetric-wood-and-blue-render.jpg 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <div className="tabs-no-padding">
      <Tabs mdxType="Tabs">
        <Tab label="Elevation" mdxType="Tab">
          <img {...{
            "src": "/workplace-xg/462adabd11cf4e5adc622ada87d8dc41/volumetric-progression-elevation.svg",
            "alt": "volumetric pattern studies",
            "title": "volumetric pattern studies"
          }}></img>
        </Tab>
        <Tab label="Section" mdxType="Tab">
          <ArtDirection mdxType="ArtDirection">
            <img {...{
              "src": "/workplace-xg/3ce818146923a23de0a526e49b18e2e8/mobile-volumetric-progression-section.svg",
              "alt": "volumetric pattern studies",
              "title": "volumetric pattern studies"
            }}></img>
            <img {...{
              "src": "/workplace-xg/f5617eb354ce562a75a640de9ecc6fe3/desktop-volumetric-progression-section.svg",
              "alt": "volumetric pattern studies",
              "title": "volumetric pattern studies"
            }}></img>
          </ArtDirection> 
        </Tab>
        <Tab label="Plan" mdxType="Tab">
          <img {...{
            "src": "/workplace-xg/703fe1e8c3af00a137c9ff0502b48fe0/volumetric-progression-plan.svg",
            "alt": "volumetric pattern studies",
            "title": "volumetric pattern studies"
          }}></img>
        </Tab>
      </Tabs>
    </div>
    <h2>{`Rotating lenticular progression`}</h2>
    <h3>{`Design`}</h3>
    <p>{`A lenticular progression transforms as viewers move around the installation. This solution works well as a semi-translucent screening element between different space types. Color and finish can be customized as needed.`}</p>
    <h3>{`Finishes`}</h3>
    <p>{`This design solution can be built in a variety of materials and finishes. The example shown here uses painted MDF—a relatively affordable solution.`}</p>
    <Row mdxType="Row">
      <Column mdxType="Column">
        <GifPlayer className="video-player" color="dark" mdxType="GifPlayer">
          <Video autoPlay playsInline loop="on" muted src="/workplace-xg/c16df33a30cd3bb065d6ad2fccfb2ab8/render-lenticular-twist.mp4" mdxType="Video" />
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAABAABA//EABQBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAU9mahJUP//EABgQAQEAAwAAAAAAAAAAAAAAAAIBESBB/9oACAEBAAEFAmqVzF0//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFREBAQAAAAAAAAAAAAAAAAAAARD/2gAIAQIBAT8BZ//EABUQAQEAAAAAAAAAAAAAAAAAABEg/9oACAEBAAY/Agr/xAAZEAEAAgMAAAAAAAAAAAAAAAABABEQQWH/2gAIAQEAAT8hP1Smi7nKBn//2gAMAwEAAgADAAAAEGff/8QAFhEBAQEAAAAAAAAAAAAAAAAAARAR/9oACAEDAQE/EAR1Z//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/EEIAT//EABoQAQACAwEAAAAAAAAAAAAAAAEAESExUWH/2gAIAQEAAT8QOCWDm4U1SNQcswfYHCIclz//2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "lenticular twist gradient render",
              "title": "lenticular twist gradient render",
              "src": "/workplace-xg/static/c8ac6ff258a3c2a96c39d3d6cb787ce5/2e753/lenticular-twist-gradient-render.jpg",
              "srcSet": ["/workplace-xg/static/c8ac6ff258a3c2a96c39d3d6cb787ce5/69549/lenticular-twist-gradient-render.jpg 288w", "/workplace-xg/static/c8ac6ff258a3c2a96c39d3d6cb787ce5/473e3/lenticular-twist-gradient-render.jpg 576w", "/workplace-xg/static/c8ac6ff258a3c2a96c39d3d6cb787ce5/2e753/lenticular-twist-gradient-render.jpg 1152w", "/workplace-xg/static/c8ac6ff258a3c2a96c39d3d6cb787ce5/74f4b/lenticular-twist-gradient-render.jpg 1728w", "/workplace-xg/static/c8ac6ff258a3c2a96c39d3d6cb787ce5/f35b7/lenticular-twist-gradient-render.jpg 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </GifPlayer>
      </Column>
    </Row>
    <div className="tabs-no-padding">
      <Tabs mdxType="Tabs">
        <Tab label="Elevation" mdxType="Tab">
          <ArtDirection mdxType="ArtDirection">
            <img {...{
              "src": "/workplace-xg/58d105cf0e579a1f3f167f81a14e4b2e/mobile-rotating-lenticular-progression-elevation.svg",
              "alt": "rotating lenticular pattern studies",
              "title": "rotating lenticular pattern studies"
            }}></img>
            <img {...{
              "src": "/workplace-xg/d61d5eb26aad365e5b5070901fd88c83/desktop-rotating-lenticular-progression-elevation.svg",
              "alt": "rotating lenticular pattern studies",
              "title": "rotating lenticular pattern studies"
            }}></img>
          </ArtDirection>
        </Tab>
        <Tab label="Plan" mdxType="Tab">
          <ArtDirection mdxType="ArtDirection">
            <img {...{
              "src": "/workplace-xg/d46c38170f08fee7be28bc6dc29669a4/mobile-rotating-lenticular-progression-plan.svg",
              "alt": "rotating lenticular pattern studies",
              "title": "rotating lenticular pattern studies"
            }}></img>
            <img {...{
              "src": "/workplace-xg/c77708202c7e74db7682ba842ad5a512/desktop-rotating-lenticular-progression-plan.svg",
              "alt": "rotating lenticular pattern studies",
              "title": "rotating lenticular pattern studies"
            }}></img>
          </ArtDirection>
        </Tab>
        <Tab label="Finishes" mdxType="Tab">
          <ArtDirection mdxType="ArtDirection">
            <img {...{
              "src": "/workplace-xg/57c0489ae93001284975d5d5d0702326/mobile-rotating-lenticular-progression-finishes.svg",
              "alt": "rotating lenticular pattern studies",
              "title": "rotating lenticular pattern studies"
            }}></img>
            <img {...{
              "src": "/workplace-xg/cacf51823c17b9b63541bd55fc91c965/desktop-rotating-lenticular-progression-finishes.svg",
              "alt": "rotating lenticular pattern studies",
              "title": "rotating lenticular pattern studies"
            }}></img>
          </ArtDirection>
        </Tab>
      </Tabs>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      